import {
    Directive,
    HostListener,
    Input,
} from '@angular/core';
import { AnalyticsService } from '@services';

@Directive({
    selector: '[uiClickTrack]',
})
export class ClickTrackDirective {
    @Input()
    public uiClickTrack!: string;

    constructor(private _analytics: AnalyticsService) { }

    @HostListener('click')
    track() {
        this._analytics.track(this.uiClickTrack);
    }
}
